import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_SERVER}/admin`;

// Gửi cookie tự động cho mọi request cross-origin
axios.defaults.withCredentials = true;

// ==================== Axios Response Interceptor ====================
// Tự động refresh token khi nhận 401 (accessToken hết hạn)
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve();
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // Xử lý 401 (token invalid) và 403 (token missing — cookie hết hạn)
    const status = error.response?.status;
    if ((status === 401 || status === 403) && !originalRequest._retry) {
      const url = originalRequest.url || '';
      if (url.includes('/user/login') ||
          url.includes('/user/refresh') ||
          url.includes('/user/logout')) {
        return Promise.reject(error);
      }

      // Nếu đang refresh → xếp hàng chờ
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => axios(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await axios.post(`${API_URL}/user/refresh`);
        processQueue(null);
        return axios(originalRequest); // Retry với cookie mới
      } catch (refreshError) {
        processQueue(refreshError);
        // Refresh thất bại → đăng xuất
        localStorage.removeItem("user");
        window.location = "/admin/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/user/login", {
        username,
        password
      })
      .then(response => {
        if (response.data.success) {
          // Chỉ lưu metadata (role, fullname) - token đã nằm trong httpOnly cookie
          localStorage.setItem("user", JSON.stringify({
            role: response.data.role,
            fullname: response.data.fullname
          }));
        }

        return response.data;
      });
  }

  refreshToken() {
    return axios
      .post(API_URL + "/user/refresh")
      .then(response => {
        if (response.data.success) {
          localStorage.setItem("user", JSON.stringify({
            role: response.data.role,
            fullname: response.data.fullname
          }));
        }
        return response.data;
      });
  }

  logout() {
    return axios
      .post(API_URL + "/user/logout")
      .then(() => {
        localStorage.removeItem("user");
        window.location = "/admin/login";
      })
      .catch(() => {
        localStorage.removeItem("user");
        window.location = "/admin/login";
      });
  }

  getCurrentUser() {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  }
}

export default new AuthService();
